import PublicLayout from "@/components/PublicLayout";
import { Factory, ShoppingBag, Wrench, HeartPulse, GraduationCap, HardHat, Ship, Home as HomeIcon, UtensilsCrossed, Briefcase, Store, Rocket } from "lucide-react";

const ITEMS = [
  { i: Factory, name: "Manufacturing", d: "Costing, inventory audits, GST reconciliations and cost audits." },
  { i: ShoppingBag, name: "Trading", d: "GST, TDS and stock accounting for wholesalers and distributors." },
  { i: Wrench, name: "Service Industry", d: "Fixed-fee compliance for agencies, consultants and freelancers." },
  { i: HeartPulse, name: "Healthcare", d: "Clinic & hospital accounting with 44ADA/44AB advisory." },
  { i: GraduationCap, name: "Education", d: "Trust registrations, 12A/80G, and payroll compliance." },
  { i: HardHat, name: "Construction", d: "Project accounting, RCM/GST on works contracts." },
  { i: Ship, name: "Export / Import", d: "IEC, LUT, RoDTEP and refund handling for exporters." },
  { i: HomeIcon, name: "Real Estate", d: "RERA support, JDA taxation and society audits." },
  { i: UtensilsCrossed, name: "Hospitality", d: "Multi-outlet accounting, GST and payroll for restaurants & hotels." },
  { i: Briefcase, name: "Professionals", d: "Doctors, lawyers and CAs — presumptive tax and MIS." },
  { i: Store, name: "Retail", d: "POS integration, GST and inventory best-practices." },
  { i: Rocket, name: "Startups", d: "DPIIT, ESOPs, cap tables and Virtual CFO." },
];

export default function Industries() {
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="text-xs uppercase tracking-widest text-blue-700">Industries We Serve</div>
        <h1 className="h-display mt-3 text-5xl md:text-6xl text-slate-900 max-w-4xl">Sector-aware advisors, not generalists.</h1>
        <p className="mt-5 max-w-2xl text-slate-600 leading-relaxed">
          Every industry has its own tax quirks and reporting rhythm. Our senior team maps our services to yours.
        </p>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((x, i) => (
            <div
              key={i}
              data-testid={`industry-${x.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
              className="rounded-2xl bg-white border border-slate-200 p-6 hover:border-blue-400 hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-11 h-11 rounded-full bg-blue-50 text-blue-700 flex items-center justify-center mb-4">
                <x.i size={20} />
              </div>
              <div className="text-lg font-medium text-slate-900">{x.name}</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
